import React from 'react';

import { Box, Typography } from '@mui/material';

import type { SurchargeCheckRowView } from './types';

interface Props {
  rule: SurchargeCheckRowView;
}

export default function SurchargeRuleDetails({ rule }: Props) {
  if (rule.field === 'Overlapping Surcharge Dates' && rule.overlappingPairs && rule.overlappingPairs.length > 0) {
    return (
      <Box>
        <Typography variant="caption" color="text.secondary">
          <strong>Overlapping pairs:</strong>
        </Typography>
        <Box component="ul" sx={{ mb: 0, mt: 0.5, pl: 2.25 }}>
          {rule.overlappingPairs.map((pair, index) => (
            <Typography key={`${pair}:${index}`} component="li" variant="caption" color="text.secondary">
              {pair}
            </Typography>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Box component="ul" sx={{ mb: 0, mt: 0, pl: 2.25 }}>
      {rule.details.map((detail) => (
        <Typography key={detail.label} component="li" variant="caption" color="text.secondary">
          <strong>{detail.label}:</strong> {detail.value}
        </Typography>
      ))}
    </Box>
  );
}
